var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimerIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6949",
    "data-name": "Group 6949",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.999,
    height: 29,
    viewBox: "0 0 28.999 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3284",
    "data-name": "Rectangle 3284",
    width: 28.999,
    height: 29,
    fill: "#2bbf79"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6948",
    "data-name": "Group 6948",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14287",
    "data-name": "Path 14287",
    d: "M15.65,2.366v.215c0,1.82,0,3.64,0,5.459a1.162,1.162,0,0,1-2.312.227c-.02-.207-.032-.416-.032-.624q0-3.018,0-6.035A5.576,5.576,0,0,1,13.336,1a1.142,1.142,0,0,1,1.11-1A12.01,12.01,0,0,1,16.769.18a14.4,14.4,0,0,1,5.419,2.031,14.757,14.757,0,0,1,4.779,4.915,14.329,14.329,0,0,1,1.878,5.284,13.466,13.466,0,0,1,.088,3.376,14.353,14.353,0,0,1-2.438,6.87,14.577,14.577,0,0,1-9.171,6.08,13.624,13.624,0,0,1-3.184.259,14.071,14.071,0,0,1-9.966-4.289A13.972,13.972,0,0,1,.791,19.327a13.454,13.454,0,0,1-.734-3.343,15.873,15.873,0,0,1,.26-4.593A14.379,14.379,0,0,1,3.126,5.5,15.276,15.276,0,0,1,4.243,4.232a1.135,1.135,0,0,1,1.59-.011,1.152,1.152,0,0,1,.054,1.616C5.456,6.347,5,6.842,4.611,7.381a11.7,11.7,0,0,0-2.2,5.4A11.94,11.94,0,0,0,5.025,22.19,12.125,12.125,0,0,0,14.719,26.7a11.893,11.893,0,0,0,7.608-2.863,11.969,11.969,0,0,0,4.044-6.57,12.214,12.214,0,0,0,.263-3.87,12.266,12.266,0,0,0-6.169-9.514,11.62,11.62,0,0,0-3.516-1.328c-.422-.086-.853-.127-1.3-.191",
    transform: "translate(0 0)",
    fill: "#2bbf79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14288",
    "data-name": "Path 14288",
    d: "M66.148,64.131A2.337,2.337,0,0,1,63.1,66.294a2.152,2.152,0,0,1-1.053-.755q-1.795-2.383-3.586-4.768c-.458-.608-.92-1.214-1.379-1.821a1.069,1.069,0,0,1-.116-1.256,1.124,1.124,0,0,1,1.7-.355c1.243.935,2.483,1.875,3.726,2.81.775.583,1.56,1.152,2.33,1.74a3.583,3.583,0,0,1,1.119,1.091,2.456,2.456,0,0,1,.3,1.15",
    transform: "translate(-49.307 -49.546)",
    fill: "#2bbf79"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerIco);
export default __webpack_public_path__ + "static/media/timer-ico.879e2339a7312e280592d53d23d883e1.svg";
export { ForwardRef as ReactComponent };